<!-- <div class="word_plugin_body">
    <div class="word_plugin_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="ms_word_section_img">
                        <img src="../../../assets/images/ms-word-img.png" alt="Microsoft word plug-in">
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="ms_word_section_text">
                        <h2>Microsoft Word용 Trinka</h2>
                        <p>MS Word에 Trinka를 플러그인하면 전보다 쉽게 효율적인 글쓰기를 할 수 있습니다! 친숙한 Word 앱에서 글쓰기와 자동 검사 모두 가능합니다. </p>
                        <div class="buttons_optinos">
                            <button class="plansButtons disabled" style="padding: 0;">출시 예정!
                            </button>
                        </div>
                        <div class="add_notes">
                            <p>* Windows 7 이상 & Word 2007 이상 버젼에서 사용 가능합니다.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="ms_process_sections">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="process_line first_chalid_section">
                        <div class="process_inner_section">
                            <img src="../../../assets/images/Download.png" alt="다운로드">
                        </div>
                        <div class="process_heading_title">
                            <h3>다운로드</h3>
                        </div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="process_line">
                        <div class="process_inner_section">
                            <img src="../../../assets/images/Install_03.png" alt="설치">
                        </div>
                        <div class="process_heading_title">
                            <h3>설치</h3>
                        </div>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="process_line last_chalid_scetion">
                        <div class="process_inner_section">
                            <img src="../../../assets/images/StartWritingBetter.png" alt="글쓰기 시작">
                        </div>
                        <div class="process_heading_title">
                            <h3>글쓰기 시작</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="better_writing_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>쉽게 더 좋은 글을 쓰세요</h2>
                    <p>Microsoft Word 애플리케이션에 플러그인하여 글을 쓰는 동시에 교정과 제안도 함께 받으십시오. 수정한 내용도 모두 자동 검사하므로 누락될 걱정이 없습니다!</p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <div class="writing_bullet_points">
                        <p>글을 쓰는 동시에 오류 교정</p>
                    </div>
                </div>

                <div class="col-sm-4">
                    <div class="writing_bullet_points">
                        <p>수정 내용 자동 검사</p>
                    </div>
                </div>

                <div class="col-sm-4">
                    <div class="writing_bullet_points">
                        <p>데이터 보안 유지</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="online_avaiable_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="avaiable_text">
                        <h2>Trinka는 클라우드 환경에서도 사용할 수 있습니다!</h2>
                        <p>Trinka Cloud는 모든 웹 브라우저에서 사용 가능합니다. 글을 클라우드에 저장하고, 언제 어디서든 빠른 수정을 받으세요!</p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <a href="https://cloud.trinka.ai" target="_blank" style="color :#000">
                        <div class="avaiable_get_started">
                            <div class="icons">
                                <img src="../../../assets/images/Get_stated_online_icons.png" alt="Get started online">
                            </div>
                            <div class="get_started_text">
                                <h3>지금 시작하기</h3>
                                <p>Trinka Cloud에 로그인</p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div> -->
<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>Microsoft Word용
                            <br /> Trinka
                            <span>프리미엄에서만</span>
                        </h1>
                        <p>MS Word에 트링카를 플러그인하면 전보다 쉽게 효율적인 글쓰기를 할 수 있습니다! 친숙한 Word 앱에서 글쓰기와 자동 검사 모두 가능합니다. </p>
                        <div class="wordPluginCTA">
                            <b id="windowInfo64bit"></b>
                            <i class="betaTagText">Beta</i>
                        </div>
                        <!-- <a> <img src="../../../assets/images/whitePaper_download.png" alt=""> 지금 다운로드</a> -->
                        <span>*Windows & Word 2010 이상 버젼에서 사용 가능합니다.</span>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/MSWordBanner.png" alt="MS_word">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="how_it_work_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <div class="howItWorkHeading">
                            <h2>이렇게 사용하세요</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/DownloadTrackChangesEdit.svg" alt="" style="width: 50px; height: 50px;">
                                </div>
                                <h3>다운로드</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/TypeOrImportFile_icon.png" alt="">
                                </div>
                                <h3>설치</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/improveYourWriting_icon.png" alt="">
                                </div>
                                <h3>글쓰기 시작</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="advanceGrammerSpellCheck_section publishEnhancements_slider accomplishSections">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="accomplishSections_img">

                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src="../../../assets/images/microsoft-wordThumbnails.jpg" alt="microsoft" class="img-fluid eposter-img">
                            <!-- <img src="https://i.ytimg.com/vi/uNNpxOtvJ80/maxresdefault.jpg" alt=""> -->
                        </a>
                    </div>
                </div>

                <div class="col-xl-6">
                    <div class="spellcheck_heading EnhancementsHeadingSection">
                        <h2>
                            Windows에서 Word용 트링카 추가
                            <br>기능 시작하기
                        </h2>
                        <div class="HeadingSubLine"></div>
                        <p>설치에 도움이 필요하신가요? 추가 기능을 사용해 수정하는 방법이 궁금하신가요?
                        </p>
                        <p>쉬운 안내 동영상과 함께 즉시 시작해 보세요.
                        </p>
                        <p>궁금한 점이 더 있으신가요?
                            <a (click)="scroll(target)" class="link">여기</a>에서 자주 묻는 질문들을 찾아보세요.
                            <!-- <a (click)="scroll(target)" class="link">here</a>. -->
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>트링카 Microsoft Word 플러그인의 주요 기능</h2>
                        <div class="HeadingSubLine"></div>
                        <p>트링카 플러그인은 여러분이 자주 사용하고 있는 MS Word 응용프로그램의 플러그인으로 이용 가능합니다. 트링카 는 글 수정 사항 및 컨셉에 따른 문장 제안을 포함한 모든 변경
                            사항을 자동으로 확인합니다.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/style_guide_icon.svg" alt="style_guide">
                        <h3>스타일 가이드의 선호 사항</h3>
                        <p>많이 활용하는 학술 스타일 가이드
                            <br />(AMA 11th, AGU 2017)에 맞게 원고의
                            <br /> 문법과 단어 선택을 올바르게 할 수 있습니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="subject_area">
                        <h3>주제분야 & 문서 유형</h3>
                        <p>주제분야 및 원고 유형에 따라 가장
                            <br />관련성이 높은것을 제안 하도록 트링카는
                            <br /> 맞춤화할 수 있습니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/AddtoDictionary.svg" alt="add_dictionary">
                        <h3>사전에 추가</h3>
                        <p>“My Dictionary"에 단어를 추가하면 향후
                            <br /> 글에서는 트링카가 철자 오류로 표시하지
                            <br /> 않습니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/DataSecurityIcon.svg" alt="data_security">
                        <h3>데이터 보안</h3>
                        <p>입력한 내용을 안전하게 전송하고 분석합니다. 트링카는 데이터를 따로 저장하지 않습니다.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/sendForHumanEditing.svg" alt="human_editing">
                        <!-- <img src="../../../assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>전문 에디터 교정 요청 </h3>
                        <p>오프라인 전문 에디터에게 최종 원고 교정을 받길 원하시나요? 트링카 에디터에서 바로이나고 교정 전문 에디터에게 원고를
                            <br />보낼수 있습니다.</p>
                    </div>
                </div>


            </div>
        </div>
    </div>
    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>FAQs</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Microsoft Word용 트링카는 어떻게 추가/설치하나요?</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>MS Word용 트링카 추가 기능 페이지를 보면 “지금 다운로드” 버튼이 있습니다. 설치 파일을 다운로드한 뒤, 해당 파일을 클릭해 설치 프로세스를
                                            시작합니다. 성공적으로 설치가 완료되면 MS Word 애플리케이션을 엽니다. 상단 리본을 보면 Trinka라는 탭이 새로이 생성되어 있습니다.
                                            탭을 클릭하고 "로그인"을 클릭하여 프리미엄 계정으로 로그인하면 트링카 사용을 시작할 수 있습니다.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">Word에서 트링카 문법 검사를 어떻게 켜나요?</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>MS Word용 트링카 추가 기능을 다운로드하여 설치했다면 트링카 계정 자격 증명을 사용하여 로그인한 뒤 리본 메뉴의 트링카 탭에서 "시작" 버튼을
                                            클릭하기만 하면 됩니다. </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        Microsoft Word에 트링카를 설치하려면 필요한 시스템 사양은 어떻게 되나요?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Windows에서 MS Word용 Trinka는 Microsoft Word 2010 이상에서 작동합니다. Mac에서의 MS Word용 추가 기능은
                                            곧 제공될 예정입니다.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Mac에서 트링카 Word 추가 기능을 사용할 수 있나요?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Mac에서 사용 가능한 MS Word용 추가 기능은 개발 중이며 곧 제공될 예정입니다.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        MS Word용 트링카 추가 기능은 맞춤법과 문법을 실시간으로 검사해 주나요?
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>예, MS Word용 트링카 추가 기능은 수정 사항을 실시간으로 확인 및 제안합니다. 또한 변경 사항을 감지하여 변경된 부분에 수정할 곳이 있는지
                                            바로 재확인합니다.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                        aria-controls="QuestionSixContent">
                                        제안 수락이나 거부는 어떻게 하나요?
                                    </a>
                                </div>

                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>제안 수락이나 거부 방법은 매우 간단합니다. 제안된 단어를 클릭하여 수정 사항을 수락/적용하거나 “거부” 아이콘을 클릭하여 거부하면 됩니다.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true"
                                        aria-controls="QuestionSevenContent">
                                        Word용 트링카 추가 기능에서 미국 영어와 영국 영어를 서로 전환할 수 있나요?
                                    </a>
                                </div>

                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>예. 리본 메뉴의 언어 확인 및 설정 메뉴 옵션에서 미국 영어와 영국 영어를 전환할 수 있습니다.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEightSection">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightSectionContent" aria-expanded="true"
                                        aria-controls="QuestionEightSectionContent">
                                        트링카 Word 추가 기능에서 스타일 가이드를 선택할 수 있나요?
                                    </a>
                                </div>

                                <div id="QuestionEightSectionContent" class="collapse" aria-labelledby="QuestionEightSection" data-parent="#faq">
                                    <div class="card-body">
                                        <p>예. 리본 메뉴의 언어 확인 및 설정 메뉴 옵션에서 원하는 스타일 가이드를 선택할 수 있습니다.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightContent" aria-expanded="true"
                                        aria-controls="QuestionEightContent">
                                        MS Word가 없어서 (Google Docs, Medium 등을 사용해) 온라인으로 글을 쓰는 경우에 Trinka를 사용하려면 어떻게 하나요?
                                    </a>
                                </div>

                                <div id="QuestionEightContent" class="collapse" aria-labelledby="QuestionEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Chrome, Firefox, Edge 브라우저용 트링카 브라우저 플러그인을 사용하면 즐겨 찾는 웹사이트에서 트링카를 사용할 수 있습니다. 여기를
                                            클릭하여
                                            <a href="/browser-plugin">트링카 브라우저 플러그인</a>을 다운로드하세요.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionTen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTenContent" aria-expanded="true"
                                        aria-controls="QuestionTenContent">
                                        설치에 성공했는데도 Word용 트링카 추가 기능을 찾을 수 없으면 어떻게 해야 하나요?
                                    </a>
                                </div>

                                <div id="QuestionTenContent" class="collapse" aria-labelledby="QuestionTen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>경우에 따라 시스템/조직 보안이 추가 기능 활성화를 막을 수도 있습니다. 파일 -> 옵션 -> 추가 기능 -> 관리 -> COM - 추가 기능에서
                                            수동으로 추가 기능을 활성화할 수 있습니다. 자세한 내용은
                                            <a href="https://youtu.be/RDrzQOBNAsk" target="_blank">이 안내 동영상을 시청</a>해 주세요.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="Question11">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question11Content" aria-expanded="true"
                                        aria-controls="Question11Content">
                                        트링카 Word 추가 기능이 오류를 감지하지 못하면 어떻게 하나요?
                                    </a>
                                </div>

                                <div id="Question11Content" class="collapse" aria-labelledby="Question11" data-parent="#faq">
                                    <div class="card-body">
                                        <p>여기에는 다양한 원인이 있을 수 있습니다.</p>
                                        <ul>
                                            <li>인터넷 연결을 확인하세요. Trinka가 오류를 감지하고 수정 사항을 제안하려면 인터넷에 연결돼 있어야 합니다.</li>
                                            <li>시스템/조직 보안 설정으로 인해 추가 기능이 비활성화된 것은 아닌지 확인합니다.
                                            </li>
                                            <li>추가 기능을 제거했다가 다시 설치합니다.</li>
                                            <li>문제가 계속될 경우
                                                <a href="mailto:support@trinka.ai">support@trinka.ai</a> 로 이메일을 보내주시면 당사 팀이 해결을 도와드리겠습니다.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>다른 앱에서
                                    <br /> 트링카 사용</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <div class="app_name_content" routerLink="/trinkacloud">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka_cloud">
                                        <h3>클라우드</h3>

                                    </div>
                                </li>
                                <li>
                                    <div class="app_name_content" routerLink="/browser-plugin">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/other_Apps_browser.svg" alt="browser-icon">
                                        <h3>브라우저
                                            <br /> 플러그인</h3>

                                    </div>
                                </li>
                                <li>
                                    <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                        <h3 style="margin: 0 0 -2px 0;">기업</h3>
                                        <span style="font-size: 11px; color: #000; position: relative;">(API, JS & On-Premise)</span>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/cTo16u94rxc"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>